import type { FaireProductEntity } from "../../entity_types/product";

export const p_7og6diq2: FaireProductEntity = {
  token: "p_7og6diq2",
  type: "product",
  name: "Sandalwood Rose - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6609c35092e2add809146be705cfb9775fc1f0689686aee5b349d4706aadb2e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc32e246f821030278e6e9e5dc48e1dcb31a941bf77f22d773718e8b37ac8073.jpeg",
    "https://cdn.faire.com/fastly/c4e15a2ed14b8fef7016f81e7f917594996a60f9c8e8c26f5893ad95cb5a77dd.jpeg",
    "https://cdn.faire.com/fastly/cb18d40fecda0f8cd27ff12d9a7207b72296d1136209d9457cc1a1de76f0fa68.jpeg",
    "https://cdn.faire.com/fastly/dcf251b4db8351b2edd624e8c187b03f6a2d8696d5f8b2412ac397924d4c2344.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "New York meets Los Angeles. Our take on a unisex floral. Notes of cashmere rose, oud, and sandalwood.\n\nThis is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nOur 7.2 oz Standard Candles are hand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. \n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:41.916Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
